import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const itemsContainerStyling: AbgSxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',

  '.MuiLink-root': {
    textDecoration: 'none',
    cursor: 'pointer',
    color: paletteBase.black,
  },
};

export const titleStyling: AbgSxProps = {
  marginTop: '8px',
  fontSize: '20px',
  fontWeight: 700,
  lineHeight: '28px',
};

export const logoutButtonStyling: AbgSxProps = {
  width: '100%',
  padding: '13px 16px',
  marginTop: 1,
  lineHeight: '14px',
  boxShadow: 'none',
};

export const alertStyling: AbgSxProps = {
  flexDirection: 'column',
  width: '100%',
  marginTop: '8px',
  backgroundColor: paletteBase.secondary400,
};
